import _ from "underscore";
import {buildQuery, parseQuery} from "utils/uri";

export default function getNewSearchParams(newSearch, currentSearch) {
  // return this not dispatch
  const params = parseQuery(currentSearch);
  const updatedSearch = buildQuery(
    _.omit({...params, ...newSearch}, value => !value),
  );
  return updatedSearch;
}
